import { Component, OnInit } from '@angular/core';
import { AdminContactService } from '../shared/service/admin-contact.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  officeDetailsArr = [];
  accountDetailsArr = [];
  frachisesDetailsArr = [];
  imageBaseUrl: string = environment.imageBaseUrl;

  constructor(private adminContactService: AdminContactService) { }


  ngOnInit() {
    this.getAccountDetails();
    this.getFrachisesDetails();
    this.getOfficeDetails();
  }

  getOfficeDetails() {
    this.adminContactService
      .getOfficeDetails()
      .then((result) => {
        this.officeDetailsArr = result
      })
      .catch((err) => console.log(err));
  }

  getFrachisesDetails() {
    this.adminContactService
      .getFrachisesDetails()
      .then((result) => {
        this.frachisesDetailsArr = result
      })
      .catch((err) => console.log(err));
  }

  getAccountDetails() {
    this.adminContactService
      .getAccountDetails()
      .then((result) => {
        this.accountDetailsArr = result
      })
      .catch((err) => console.log(err));
  }


}
